/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowsAltH} from '@fortawesome/pro-duotone-svg-icons';

const MeetingIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faArrowsAltH} {...props} />
);

export default MeetingIcon;
